import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import { Alert, Grid, Typography, Paper, Button, Box, Table, TableBody, TableRow, TableCell, Tooltip, Stack, Stepper, Step, StepLabel } from "@mui/material";

import { SessionContext } from "../../SessionContext";
// import AlertDialog from "../PopUps/AlertDialog";


import palette from "../../theme/palette";
import { AppContext } from "../../AppContext";
import Dataroomcard from "../Common/Dataroomcard";
import SellersCard from "../Common/SellersCard";
import BuyersCard from "../Common/BuyersCard";
import PriceCard from "../Common/PriceCard";
import DealMainInfos from "../Common/DealMainInfos";
import DealStatusCardP from "../Common/DealStatusCardP";
import { redThreadDealUser } from "../Common/redthread";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import NotariesCard from "../Common/NotariesCard";

export default function DealDashboardP({ id, ...rest }) {
	const [state, setState] = useContext(SessionContext);
	const app = useContext(AppContext);
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/35ec200fc2984db68807bb6268d1bd78/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							actualDeal: res.pld,
						}));
						if (rest.matches && rest.matches.inv_ntr === "1") {
							app.refPopUp.current.handleChangeState(
								{
									opened: true,
									type: "010",
									uid: id,
									side: "AC"
								}
							)
						}
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	console.log("state", state);
	if (state.actualDeal === undefined) {
		return;
	}

	useEffect(() => {

		redThreadDealUser(state, app);

	}, [state]);

	const steps = ["En vente", "Offre", "Promesse", "Acte authentique"];

	return (
		<div style="margin-top: 40px; margin-left: 50px; margin-right: 50px;">
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper style="padding: 10px">
						<Grid container alignItems="center">
							{false && (
								<Box p={1}>
									<Typography variant="h3">Tableau de bord acquéreur</Typography>
								</Box>
							)}
							<Grid item xs={8}>
								<Stepper activeStep={state.actualDeal.auth_signed ? 4 : state.actualDeal.acc ? 3 : state.actualDeal.oabs ? 2 : 0} alternativeLabel>
									{steps.map((label) => (
										<Step key={label}>
											<StepLabel>{label}</StepLabel>
										</Step>
									))}
								</Stepper>
							</Grid>
							<Grid item xs={4}></Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Grid container spacing={2}>
						<Grid item xs={12} md={4}>

							<PriceCard actualDeal={state.actualDeal} mode="P" />
							<DealMainInfos state={state} uid={id} mode="P" />
						</Grid>
						<Grid item xs={12} md={4}>
							<Stack spacing={1}>
								<SellersCard actualDeal={state.actualDeal} mode="AC" />
								{/*  */}
								{state.actualDeal.oabs && (

									<BuyersCard actualDeal={state.actualDeal}
										mode="AC"
										btn={state.actualDeal.idp && <ButtonWithTooltipAndBadge
											tooltip={state.actualDeal.idp ? "Gérer les acquéreurs" : "Gérer mes informations"}
											icon={state.actualDeal.idp ? <GroupAddIcon /> : <AccountBoxIcon />}
											onclick_cb={() => {

												window.location.href = state.actualDeal.idp ? (state.actualDeal.buyers.length == 1 ? "/du/" + state.actualDeal.buyers[0].uid + "?from=" + window.location.href : "/buyers/" + id) : "/du/" + state.actualDeal.uid + "?from=" + window.location.href;
											}}
											badge={false} />}
									/>)}

								{state.actualDeal && state.actualDeal.oabs && (
									<NotariesCard actualDeal={state.actualDeal} mode="AC" />
								)}
							</Stack>
						</Grid>
						<Grid item xs={12} md={4}>
							<Stack spacing={1}>
								<DealStatusCardP state={state} uid={id} />

								<Dataroomcard id={id} stats={state.actualDeal.stats} flag={state.actualDeal.dataroom_flag} />
							</Stack>
						</Grid>

					</Grid>
				</Grid>
			</Grid >
		</div >
	);
}
